import { axiosInstance } from "../../../axios/axiosInstance";

const API_TERMS_AND_CONDITIONS_URL = "admin/policy";
const API_CREATE_TERMS_AND_CONDITIONS_MODULE_URL = API_TERMS_AND_CONDITIONS_URL + "/save";

export const createTermsAndConditions = (dataToBeSent, dataToBeSentForPayload) => {
  return axiosInstance.post(API_CREATE_TERMS_AND_CONDITIONS_MODULE_URL + "/" + dataToBeSent?.type, dataToBeSentForPayload);
};